import { render, staticRenderFns } from "./BannerSliderHeader.vue?vue&type=template&id=08246674"
import script from "./BannerSliderHeader.vue?vue&type=script&lang=js"
export * from "./BannerSliderHeader.vue?vue&type=script&lang=js"
import style0 from "./BannerSliderHeader.vue?vue&type=style&index=0&id=08246674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports